import React, { Component } from "react";
import { styled, SystemProps, th } from "@veracity/vui"
import { LazyPasswordEntropy } from "../utils/LazyPasswordEntropy";
import { identityClient } from "..";
import { Observer } from "mobx-react-lite";

export const PasswordStrengthMeterBase = styled.divBox<{ strength: number; }>`
    background: ${th.color("grey.20")};
    position: relative;
	height: 4px;

    &:before {
        background: ${p => {
            switch (p.strength) {
                case 0:
                    return th.color("red.80");
                case 1:
                case 2:
                    return th.color("yellow.80");
                case 3:
                    return th.color("blue.80");
                case 4:
                    return th.color("green.80");
            }
        }};
        bottom: 0;
        content: "";
        display: block;
        left: 0;
        position: absolute;
        top: 0;
        transition: all ${th.animation("standard")} .2s;
        width: ${p => (p.strength + 1) * 100 / 5}%;
    }
`;

export interface PasswordStrengthMeterProps extends SystemProps {
    password: string;
}

export class PasswordStrengthMeter extends Component<PasswordStrengthMeterProps> {

    constructor(props: PasswordStrengthMeterProps) {
        super(props);
        this._lazyPasswordEntropy = new LazyPasswordEntropy(props.password, identityClient);
    }

    private _lazyPasswordEntropy: LazyPasswordEntropy;

    shouldComponentUpdate(nextProps: Readonly<PasswordStrengthMeterProps>, nextState: Readonly<{}>, nextContext: any) {
        this._lazyPasswordEntropy.password = nextProps.password;
        return true;
    }

    render() {
        
        let { password, ...rest } = this.props;

        return <Observer>{() => <PasswordStrengthMeterBase strength={this._lazyPasswordEntropy.state.result?.Score} {...rest} />}</Observer>;
    }
}